// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/timer.js';

import { paths } from '../generated/timer';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('timer', Original, paths);
